import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import '../assets/css/includes/slider.css';

// Import images
import image1 from '../assets/images/Slider-img/Banana.jpg';
import image2 from '../assets/images/Slider-img/CustardApple.jpg';
import image3 from '../assets/images/Slider-img/Guava.jpg';
import image4 from '../assets/images/Slider-img/Mango.jpg';
import image5 from '../assets/images/Slider-img/Pomegranate.jpg';

const NextArrow = ({ onClick }) => (
    <div className="arrow next" onClick={onClick}>
      <FaChevronRight />
    </div>
  );
  
  const PrevArrow = ({ onClick }) => (
    <div className="arrow prev" onClick={onClick}>
      <FaChevronLeft />
    </div>
  );
  const CustomArrows = ({ next, previous }) => (
    <div>
      <NextArrow onClick={next} />
      <PrevArrow onClick={previous} />
    </div>
  );

  const Imgslider = ({ sliderText }) => {
  const settings = {
    infinite: true,
    // fade: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    customPaging: function(i) {
        return <a></a>;
      },
      appendDots: dots => (
        <div>
          <ul>{dots}</ul>
        </div>
      ),
  };

  const images = [image2, image3, image4,image1,];

  return (
    <div className="slider-container">
      <div className="content-overlay">
        {/* Use the provided custom text and style */}
        <h1 className="slider-text">{sliderText}</h1>
        <Slider {...settings}>
        {images.map((image, index) => (
          <div key={index} className="slider-image">
          <img className='img-slide' src={image} alt={`Slide ${index + 1}`} />
          </div>
          ))}
          </Slider>
          </div>
    </div>
  );
};


export default Imgslider;
